import { requests } from "../../../../../services/external/APIs/apiAgent"
import { EventModel } from "../model/EventModel";

const API_URL = 'dublin/api/v2.0.0/events'

export const getEventsByUser = async (StartDate: string, EndDate: string) : Promise<EventModel[]> => 
    requests.post(`${API_URL}/by-user`,{StartDate, EndDate});